"use client";

import { Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { testimonials } from "@/content/testimonials";

export function TestimonialsSection() {
  const sectionRef = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    staggerInterval: 100,
  });

  return (
    <section
      ref={sectionRef}
      id="testimonials"
      className="bg-white py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        {/* Section Header */}
        <div className="reveal mb-20 text-center">
          <div className="text-luxury-green mb-6 inline-flex items-center space-x-3">
            <div className="bg-luxury-green h-0.5 w-12" />
            <span className="text-sm font-semibold tracking-[0.3em] uppercase">
              Отзывы
            </span>
            <div className="bg-luxury-green h-0.5 w-12" />
          </div>
          <h2 className="font-display text-luxury-dark mb-6 text-5xl font-bold lg:text-7xl">
            Что говорят клиенты
          </h2>
          <p className="text-luxury-stone mx-auto max-w-3xl text-xl">
            1000+ проектов, 0 недовольных клиентов — результат говорит сам за
            себя.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid gap-8 lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-luxury-cream reveal p-8"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="mb-6 flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="text-luxury-green h-5 w-5 fill-current"
                  />
                ))}
              </div>
              <p className="text-luxury-stone mb-6 italic">
                «{testimonial.text}»
              </p>
              <div className="flex items-center space-x-4">
                <div className="bg-luxury-green/20 h-12 w-12 rounded-full" />
                <div>
                  <p className="text-luxury-dark font-semibold">
                    {testimonial.name}
                  </p>
                  <p className="text-luxury-stone text-sm">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
